// Ported verbatim from static/app.js (formatCurrency / formatMaybeCurrency / formatDateTime).

export function formatCurrency(value: number | string | null | undefined, currency = "USD"): string {
  const number = Number(value);
  if (!Number.isFinite(number)) {
    return "N/A";
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: Math.abs(number) >= 100 ? 2 : 4,
  }).format(number);
}

export function formatMaybeCurrency(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === "") {
    return "N/A";
  }

  return formatCurrency(value);
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) {
    return "not yet";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
}
